import React from "react";

import PerfectScrollbar from "react-perfect-scrollbar";

import useSidebar from "../../hooks/useSidebar.js";
import SidebarNav from "./SidebarNav.js";
import Logo from "../../assets/img/r1eventech-logo.png";
import { HelpCenter } from "../help/HelpCenter.js";
import useAuth from "../../hooks/useAuth.js";

import { clearEventsState } from "../../redux/eventsStorage.js";

const Sidebar = ({ items }) => {
  const { isOpen } = useSidebar();
  const { tipo } = useAuth();

  function goToHomepage() {
    clearEventsState();
    window.location.href = "/";
  }

  return (
    <nav className={`sidebar ${!isOpen ? "collapsed" : ""}`}>
      <div className="sidebar-content">
        <PerfectScrollbar className="sidebar-navigation-scroll">
          <img
            src={Logo}
            alt="R1 Eventech"
            className="img-fluid px-5 py-4 cursor-pointer"
            onClick={() => {
              goToHomepage();
            }}
          />
          <SidebarNav items={items} />
        </PerfectScrollbar>
        <HelpCenter isAdmin={Number(tipo) === 1} />
      </div>
    </nav>
  );
};

export default Sidebar;
